import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useChSendDataGuardPatientConsentMutation as useChSendDataGuardPatientConsentMutationType } from "@/modules/patients/information/consent/ch/services/__generated__/useChSendDataGuardPatientConsentMutation.graphql"

const mutation = graphql`
  mutation useChSendDataGuardPatientConsentMutation($input: Ch_sendDataGuardPatientConsentInput!) {
    ch_sendDataGuardPatientConsent(input: $input) {
      boolean
    }
  }
`

const useChSendDataGuardPatientConsentMutation = () => {
  const [commit, isFlight] = useMutation<useChSendDataGuardPatientConsentMutationType>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChSendDataGuardPatientConsentMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChSendDataGuardPatientConsentMutation }
